import { createFileRoute } from "@tanstack/react-router";
import Embudo5Estrellas from "../../pages/soluciones/Embudo5Estrellas";

export const Route = createFileRoute("/que-hacemos/embudo-5-estrellas")({
  component: Embudo5Estrellas,
});
